import styled, { css, DefaultTheme } from 'styled-components';

export default styled.div`
  ${({ theme }: { theme: DefaultTheme }) => {
  return css`
    justify-content: center;
    align-items: center;
    padding: 0 1em;

    @media ${theme.mq.max.mobile} {
      width: calc(100dvw - 4em) !important;
    }

    height: calc(100dvh - 6.25em);
    @media ${theme.mq.min.tablet} {
      height: calc(100dvh - 3em);
      max-height: 43.625em;
    }

    .login-panel__title {
      text-align: center;
      font-size: 1em;
      line-height: 1.5;
      font-weight: 700;
      color: var(--color-neutral-60);
      margin: 2em 0 1.5em;
      display: block;
    }
    .login-panel__btn {
      margin-top: 0.5em;
    }
    .login-panel__input {
      margin-bottom: 0.5em;
    }
    .login-panel__container {
      max-width: 20.5em;
      width: 100%;
    }
  `;
  }}
`;
